import { render } from "./fixedTab.vue?vue&type=template&id=b9fa2c48&scoped=true"
import script from "./fixedTab.vue?vue&type=script&lang=js"
export * from "./fixedTab.vue?vue&type=script&lang=js"

import "./fixedTab.vue?vue&type=style&index=0&id=b9fa2c48&lang=scss"
import "./fixedTab.vue?vue&type=style&index=1&id=b9fa2c48&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9fa2c48"]])

export default __exports__